export default __webpack_public_path__ + "static/media/box03.37b63b36.png";